import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from "./store/context/Context";
import reportWebVitals from './reportWebVitals';
import { SnackbarProvider } from 'notistack';
import { Theme, useTheme, ThemeProvider } from "@mui/material/styles";
import { BeautifulTheme } from './Theme/BeautifulTheme';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <SnackbarProvider maxSnack={3} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
      <Provider>
        <ThemeProvider theme={BeautifulTheme}>
          <App />
        </ThemeProvider>
      </Provider>
    </SnackbarProvider>

  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
